export default __webpack_public_path__ + "static/TCP_CanopyStyle_and_Pack4Good__Pledge-57128e1b5d6a744a195cafab20c8aa72.pdf";